import React from 'react';
import { Button } from 'antd';
import { useNavigate } from "react-router-dom";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faFilePdf, faBars } from '@fortawesome/free-solid-svg-icons';

import ModalConfirmSend from 'Components/commonComponents/modalSendEmail';

import emailHooks from './hooks_email';
import { ROUTES } from '@/App/Router/routes';

import './index.css';


const HeaderQuotationComparatorsDiff = ({ actionsDisabled, quotationId, urlPdf }) => {
  const navigate = useNavigate();

  const [modalEmails, handleShowModalSendEmail, idQuotation] = emailHooks();

  const handleShowModalViewQuotations = (quotationId) => {
    // localStorage.setItem('consulting', false);
    navigate(ROUTES.QUOTATIONS.PLANS.LIST(quotationId));
  };

  return (
    <div className="c01211 c01213 c01212" style={{ borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>

      <div className="container-button-send" style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', margin: '0 auto' }}>
        <div className="button_enviar_cotizacion">
          <Button type="primary" disabled={actionsDisabled} onClick={() => handleShowModalSendEmail(quotationId)}>
            <span>
              <FontAwesomeIcon icon={faEnvelope} />
              &nbsp;Enviar Cotización
            </span>
          </Button>
        </div>
        {urlPdf ?
          <a className="button_enviar_cotizacion" href={urlPdf} target="_blank">
            <Button type="primary">
              <span>
                <FontAwesomeIcon icon={faFilePdf} />
                &nbsp;Generar PDF
              </span>
            </Button>
          </a>
        : null}
        <div className="button_enviar_cotizacion">
          <Button type="primary" onClick={() => handleShowModalViewQuotations(quotationId)}>
            <span>
              <FontAwesomeIcon icon={faBars} />
              &nbsp;Ver todos los planes
            </span>
          </Button>
        </div>
      </div>

      {!actionsDisabled && (
        <ModalConfirmSend
          visible={modalEmails.isVisible}
          handleCancel={modalEmails.handleCancel}
          title="Enviar Cotización"
          label="Ingresa los E-mails a los que deseas enviar la cotización"
          placeholder="E-mails"
          idQuotation={idQuotation}
        />
      )}
    </div>
  );
};

export default HeaderQuotationComparatorsDiff;
